import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';

function OrgaosFormPage() {
  // Estados do formulário
  const [nome, setNome] = useState('');
  const [sigla, setSigla] = useState('');

  // Estados de controle
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Órgão' : 'Novo Órgão';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar um novo órgão';

  // Efeito para buscar o órgão em caso de edição
  useEffect(() => {
    if (id) {
      const fetchOrgao = async () => {
        setLoading(true);
        try {
          const response = await api.get(`/orgaos/${id}`);
          const { nome, sigla } = response.data.data;
          setNome(nome);
          setSigla(sigla);
        } catch (err) {
          setError('Não foi possível carregar os dados do órgão.');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchOrgao();
    }
  }, [id]);

  // Manipulador para o envio do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const orgaoData = { nome, sigla };

    try {
      if (id) {
        await api.put(`/orgaos/${id}`, orgaoData);
      } else {
        await api.post('/orgaos', orgaoData);
      }
      navigate('/painel/orgaos');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar o órgão. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <div className="orgaos-form-page">
        <LoadingSpinner text="Carregando dados do órgão..." />
      </div>
    );
  }

  return (
    <div className="orgaos-form-page">
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card orgaos-form-card">
        <div className="card-body">
          <form className="orgaos-form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label htmlFor="nome" className="form-label">Nome do Órgão</label>
              <input
                type="text"
                className="form-control"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="sigla" className="form-label">Sigla</label>
              <input
                type="text"
                className="form-control"
                id="sigla"
                value={sigla}
                onChange={(e) => setSigla(e.target.value)}
                required
              />
            </div>

            <div className="orgaos-form-actions d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/orgaos')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default OrgaosFormPage;
